import { render, staticRenderFns } from "./data-table-filter.vue?vue&type=template&id=0607b4fb&scoped=true&lang=pug&"
import script from "./data-table-filter.vue?vue&type=script&lang=ts&"
export * from "./data-table-filter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0607b4fb",
  null
  
)

export default component.exports